/* Developed by MontenegroSoft - www.montenegrosoft.com */

(() => {

    const SPEED = {
        1: 1.2,
        2: 2.4,
        3: 3.6,
        4: 4.8
    }

    document.querySelectorAll('.ms-auto-carousel').forEach(carousel => {

        const track = carousel.querySelector('.ms-auto-carousel-track')

        track.addEventListener('dragstart', e => e.preventDefault())

        const levelAttr = parseInt(carousel.dataset.msSpeed, 10)
        const level = SPEED[levelAttr] ? levelAttr : 2
        const speed = SPEED[level]

        let baseWidth = 0
        let position = 0
        let isDown = false
        let startX = 0
        let startPosition = 0

        function build() {
            const content = track.innerHTML
            const containerWidth = track.parentElement.offsetWidth

            while (track.scrollWidth < containerWidth * 2) {
                track.innerHTML += content
            }

            baseWidth = track.scrollWidth / 2
        }

        function normalize() {
            if (!baseWidth) return
            if (position <= -baseWidth) position += baseWidth
            if (position >= 0) position -= baseWidth
        }

        function loop() {
            if (!isDown) {
                position -= speed
                normalize()
                track.style.transform = `translate3d(${position}px,0,0)`
            }
            requestAnimationFrame(loop)
        }

        function down(e) {
            isDown = true
            startX = e.touches ? e.touches[0].clientX : e.clientX
            startPosition = position
        }

        function move(e) {
            if (!isDown) return
            const x = e.touches ? e.touches[0].clientX : e.clientX
            position = startPosition + (x - startX)
            normalize()
            track.style.transform = `translate3d(${position}px,0,0)`
        }

        function up() {
            isDown = false
        }

        function init() {

            const images = track.querySelectorAll('img')

            if (!images.length) {
                build()
                loop()
                return
            }

            let loaded = 0

            images.forEach(img => {

                if (img.complete) {
                    loaded++
                } else {

                    img.addEventListener('load', () => {
                        loaded++
                        if (loaded === images.length) {
                            build()
                            loop()
                        }
                    })

                    img.addEventListener('error', () => {
                        loaded++
                        if (loaded === images.length) {
                            build()
                            loop()
                        }
                    })

                }

            })

            if (loaded === images.length) {
                build()
                loop()
            }

        }

        track.addEventListener('mousedown', down)
        window.addEventListener('mousemove', move)
        window.addEventListener('mouseup', up)

        track.addEventListener('touchstart', down, { passive: true })
        window.addEventListener('touchmove', move, { passive: true })
        window.addEventListener('touchend', up)

        init()

    })

})()